module.exports = __webpack_public_path__ + "static/img/df.8b65ace.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/df.png
// module id = b+wM
// module chunks = 1